export default "/_next/static/images/df587e92c68abcf63fe7bcf9daeae33e.jpg";